export default __webpack_public_path__ + "static/media/13exigo.0f3e04d3.jpg";